var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H13.25V8C13.25 8.9665 14.0335 9.75 15 9.75H20.9992C20.9997 9.76904 21 9.78811 21 9.80721V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2ZM10.7143 16.9904C10.7143 16.4968 11.0197 16.0629 11.4252 15.771C12.3824 15.0819 13 13.9947 13 12.7715C13 10.6886 11.2091 9 9 9C6.79086 9 5 10.6886 5 12.7715C5 13.9947 5.61757 15.0819 6.57476 15.771C6.98026 16.0629 7.28571 16.4968 7.28571 16.9904C7.28571 17.3385 7.57317 17.6207 7.92776 17.6207H10.0722C10.4268 17.6207 10.7143 17.3385 10.7143 16.9904ZM7.15737 19.3131C7.15737 19.6925 7.47067 20 7.85714 20H10.1429C10.5293 20 10.8426 19.6925 10.8426 19.3131C10.8426 18.9338 10.5293 18.6262 10.1429 18.6262H7.85714C7.47067 18.6262 7.15737 18.9338 7.15737 19.3131Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 2.61172L20.2768 8.24999H15C14.8619 8.24999 14.75 8.13806 14.75 7.99999V2.52417C14.7808 2.55232 14.8108 2.58151 14.8399 2.61172Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIdea);
export default __webpack_public_path__ + "static/media/paper-idea.3153893d00c63a0967c332a56a940b05.svg";
export { ForwardRef as ReactComponent };